import React, { useEffect, useState } from "react";
import ParentAgencySelect from "./ParentAgencySelect";
import AgencyTypesSelect from "./AgencyTypesSelect";

import { getAgencyData } from "api/search.api";
import { useAppSelector } from "hooks/reduxHooks";

interface AgencyTreeSelecterProps {
  industryChangeTrigger?: null | number;
  agencyTypeChangeTrigger: null | number;
  parentIndustryChangeTrigger: null | number;
  handelAgencyTypeChange: any;
  onParentAgencyChange: any;
}
const AgencyTreeSelecter: React.FC<AgencyTreeSelecterProps> = ({ 
  industryChangeTrigger, 
   agencyTypeChangeTrigger,
   parentIndustryChangeTrigger,
   handelAgencyTypeChange,
   onParentAgencyChange
  
  }) => {
  const [agencyListData, setAgencyListData] = useState<any>([]);
  const [parsedAgencyData, setParsedAgencyData] = useState<any>([]);
  const industryType = useAppSelector((state) => state.search.industry_type);
 
  const isMartech =
    industryType.indexOf("martech") > -1 ||
    industryType.indexOf("Martech") > -1 ||
    industryType.indexOf("Adtech") > -1 ||
    industryType.indexOf("adtech") > -1 ||
    industryType.indexOf("Adtech/Martech") > -1;

  useEffect(() => {
    if (agencyListData) {
      getAgencyData(isMartech).then((data: any) => {
        setAgencyListData(data);
        const parsedData = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          parsedData.push({
            label: element.name,
            value: element.name,
          });
        }
        setParsedAgencyData(parsedData);
      });
    }
  }, [isMartech]);

  return (
    <>
      <label className="search-input-headings">Agency Tree Selector</label>
      <div className="my-5">
        <ParentAgencySelect
          parsedAgencyData={parsedAgencyData}
          industryChangeTrigger={industryChangeTrigger}
          onParentAgencyChange={onParentAgencyChange}
        />
        <AgencyTypesSelect
          agencyListData={agencyListData}
          parentIndustryChangeTrigger={parentIndustryChangeTrigger}
          agencyTypeChangeTrigger={agencyTypeChangeTrigger}
          handelAgencyTypeChange={handelAgencyTypeChange}
        />
      </div>
    </>
  );
};

export default AgencyTreeSelecter;
